import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, Input, InputAdornment, InputLabel, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { getTenantLocalStorage } from "../../../service/tenant/TenantService";
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import PrincipalLayout from "../menu/PrincipalLayout";
import { Delete, EditNote, Search } from "@mui/icons-material";
import { logicalDeleteInvoice, searchInvoicesByAnyAttributeAndStatus } from "../../../service/tenant/InvoiceService";
import ErrorMessageChip from "../util/ErrorMessageChip";
import constants from "../util/Constants";
import { useNavigate } from "react-router";
import SuccessMessageChip from "../util/SuccessMessageChip";
import { getAllActiveClients } from "../../../service/tenant/ClientService";
import AutocompleteComponent from "../util/AutocompleteComponent";
import { getAllActiveProjectsByClientId } from "../../../service/tenant/ProjectService";
import { getInvoiceStatusName, getInvoiceStatusValues } from "../../../service/tenant/StatusService";
import { convertDateStrISOString, convertDateStrToString } from "../../../service/tenant/ValidationService";
import { searchJobsByAnyAttribute } from "../../../service/tenant/JobService";
import { searchWorkOrdersByAnyAttribute, searchWorkOrdersByAnyAttributeForClient } from "../../../service/tenant/WorkOrderService";
import SelectComponent from "../util/SelectComponent";



function ViewInvoices(props){
    

    const [tableRows, setTableRows] = useState([]);
    const [searchFilter, setSearchFilter] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
    const [invoiceToDelete, setInvoiceToDelete] = useState(null);
    const [client, setClient] = useState(null);
    const [activeClients, setActiveClients] = useState([]);
    const [project, setProject] = useState(null);
    const [activeProjects, setActiveProjects] = useState([]);
    const [job, setJob] = useState(null);
    const [activeJobs, setActiveJobs] = useState([]);
    const [workOrder, setWorkOrder] = useState(null);
    const [activeWorkOrders, setActiveWorkOrders] = useState([]);
    const [visibleStatus, setVisibleStatus] = useState([]);
    const [status, setStatus] = useState(null);
    

    const tenant = getTenantLocalStorage();
    const tenantId = tenant.id;
    const navigate = useNavigate();


    useEffect( () => {
        setIsLoading(true);
        getAllActiveClients( tenantId ).then( activeClientsResponse => {
            if( activeClientsResponse != null ){
                setActiveClients(activeClientsResponse);
            }
            setIsLoading(false);
        });

        const visibleStatusAux = getInvoiceStatusValues();
        setVisibleStatus(visibleStatusAux);

    }, []);

    useEffect( () => {
        console.log('[ViewInvoices][useEffect] client: ', client);
        
        if( client ){
            const clientId = client.id;

            setIsLoading(true);
            getAllActiveProjectsByClientId(clientId, tenantId).then( activeProjectsResponse => {
                if( activeProjectsResponse != null ){
                    setActiveProjects(activeProjectsResponse);
                }
                setIsLoading(false);
            });

            setIsLoading(true);
            searchJobsByAnyAttribute('', clientId, '', tenantId).then( activeJobsResponse => {
                if( activeJobsResponse != null ){
                    setActiveJobs(activeJobsResponse);
                }
                setIsLoading(false);
            });

            setIsLoading(true);
            searchWorkOrdersByAnyAttributeForClient('', clientId, '', '', tenantId).then( activeWorkOrdersResponse => {
                if( activeWorkOrdersResponse != null ){
                    setActiveWorkOrders(activeWorkOrdersResponse);
                }
                setIsLoading(false);
            });

        }
    }, [client]);

    const handleSearchInvoices = () => {
        const tenantId = tenant.id;
        
        if( (!searchFilter || searchFilter === '') && client === null && status === null ){
            setErrorMessage(constants.errors.searchFilterEmpty);
            return;
        }

        setErrorMessage('');
        setTableRows([]);

        setIsLoading(true);

        let clientId = '';
        let projectId = '';
        let jobId = '';
        let workOrderId = '';

        if( client ){
            clientId = client.id;
            if( project ){
                projectId = project.id;
            }
            if( job ){
                jobId = job.id;
            }
            if( workOrder ){
                workOrderId = workOrder.id;
            }
        }

        searchInvoicesByAnyAttributeAndStatus(searchFilter, clientId, projectId, jobId, workOrderId, status, tenantId).then( invoiceList => {

            if( invoiceList !== null ){
                console.debug('[ViewInvoices][handleSearchInvoices] invoiceList: ', invoiceList);

                if( invoiceList.length > 0 ){
                    setTableRows(invoiceList);
                } else {
                    setErrorMessage(constants.errors.emptyResult);
                }
            } else {
                setErrorMessage(constants.errors.searchInvoiceError);
            }

            setIsLoading(false);
            
        });
    }

    const handleEditInvoice = (invoiceId) => {
        console.debug('[ViewInvoices][handleEditInvoice] invoiceId: ', invoiceId);
        navigate(constants.routes.editInvoice, {
            state: {
                invoiceId: invoiceId
            }
        });
    }

    const handleEditClient = (clientId) => {
        if( clientId != null ) { 
            console.debug('[ViewClients][handleEditClient] clientId: ', clientId);
            navigate(constants.routes.editClient, {
                state: {
                    clientId: clientId
                }
            });
        }
    }

    const handleEditJob = (jobId) => {
        if( jobId != null ) { 
            console.debug('[ViewClients][handleEditJob] jobId: ', jobId);
            navigate(constants.routes.editJob, {
                state: {
                    jobId: jobId
                }
            });
        }
    }

    const handleEditWorkOrder = (workOrderId) => {
        if( workOrderId != null ) { 
            console.debug('[ViewClients][handleEditWorkOrder] workOrderId: ', workOrderId);
            navigate(constants.routes.editWorkOrder, {
                state: {
                    workOrderId: workOrderId
                }
            });
        }
    }

    const handleNewInvoice = () => {
        navigate(constants.routes.createInvoice, {
            state: {
                invoiceId: ''
            }
        });
    }

    const handleDeleteInvoice = (invoice) => {
        console.debug('[ViewInvoices][handleDeleteInvoice] invoice: ', invoice);
        setInvoiceToDelete(invoice);
        setOpenDeleteAlert(true);
    }

    const handleConfirmDeleteInvoice = () => {
        console.debug('[ViewInvoices][handleConfirmDeleteInvoice] ');

        const tenantId = tenant.id;

        setOpenDeleteAlert(false);
        setIsLoading(true);

        logicalDeleteInvoice(invoiceToDelete, tenantId).then( (deleteResponse) => {
            console.debug('[ViewInvoices][handleConfirmDeleteInvoice] deleteResponse: ', deleteResponse);

            if( deleteResponse != null ){
                setSuccessMessage(constants.errors.deleteInvoiceSuccess);

                handleSearchInvoices();

            } else {
                setErrorMessage(constants.errors.deleteInvoiceError);
            }

            setIsLoading(false);
            setInvoiceToDelete(null);
        })

        
    }

    const handleCloseDeleteDialog = () => {
        setInvoiceToDelete(null);
        setOpenDeleteAlert(false);
    }

    const handleChangeClient = (attributeName, newClient) => {
        console.debug('[ViewInvoices][handleChangeClient] newClient: ', newClient)
        setClient(newClient);
        setActiveProjects([]);
        setProject(null);
    }

    const handleChangeProject = (attributeName, newProject) => {
        console.debug('[ViewInvoices][handleChangeClient] newProject: ', newProject)
        setProject(newProject);
    }

    const handleChangeJob = (attributeName, newJob) => {
        console.debug('[ViewInvoices][handleChangeJob] newJob: ', newJob)
        setJob(newJob);
    }

    const handleChangeWorkOrder = (attributeName, newWorkOrder) => {
        console.debug('[ViewInvoices][handleChangeWorkOrder] newWorkOrder: ', newWorkOrder)
        setWorkOrder(newWorkOrder);
    }

    const handleChangeStatus = (attributeName, newStatus) => {
        console.debug('[ViewInvoices][handleChangeStatus] newStatus: ', newStatus);
        setStatus(newStatus);
    } 


    return (
        <PrincipalLayout section={constants.menu.admin_invoices_section} isLoading={isLoading} 
                        notificationNumber={props.notificationNumber} 
                        setNotificationNumber={props.setNotificationNumber}
        >

                <Toolbar />

                <Paper sx={constants.styles.paperContainer}>
                    <Grid container direction="row" spacing={0}
                        justifyContent={'left'}
                        alignContent={'center'}
                        alignItems={'center'}
                    >
                        <Grid item sx={constants.styles.sectionTitle} xs={12} md={12}>
                            <Typography 
                                variant="h6"
                                sx={constants.styles.textTitle}
                            >
                                Invoices &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </Typography>
                            
                        </Grid>
                        
                        <Grid item sx={constants.styles.sectionInput} xs={2} md={2}>
                            <Typography sx={constants.styles.textNormal}>
                                Search for invoice:
                            </Typography>
                        </Grid>
                        <Grid item sx={constants.styles.sectionInput} xs={9} md={9}>
                            <FormControl variant="standard">
                                <InputLabel htmlFor="input-user-search" sx={constants.styles.textNormal}>
                                    Type invoice number
                                </InputLabel>
                                <Input
                                    id="input-user-search"
                                    value={searchFilter}
                                    sx={constants.styles.inputSearchNormal}
                                    onChange={ (e) => setSearchFilter(e.target.value) }
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                edge="end"
                                                size="small"
                                                onClick={handleSearchInvoices}
                                            >
                                                <Search />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    
                                />
                            </FormControl>
                        </Grid>

                        <AutocompleteComponent
                            fieldId={'input-invoice-client'}
                            fieldName={'Client'} 
                            fieldValue={client}
                            attributeName={'client'}
                            optionList={activeClients}
                            isClient={true}
                            handleChangeField={handleChangeClient}

                            labelSx={2}
                            labelMd={2}

                            inputSx={9}
                            inputMd={9}
                        />

                        <AutocompleteComponent
                            fieldId={'input-invoice-project'}
                            fieldName={'Project'} 
                            fieldValue={project}
                            attributeName={'project'}
                            optionList={activeProjects}
                            optionAttributeLabel={'name'}
                            isClient={false}
                            handleChangeField={handleChangeProject}

                            labelSx={2}
                            labelMd={2}

                            inputSx={9}
                            inputMd={9}
                        />

                        <AutocompleteComponent
                            fieldId={'input-invoice-job'}
                            fieldName={'Job'} 
                            fieldValue={job}
                            attributeName={'job'}
                            optionList={activeJobs}
                            optionAttributeLabel={'title'}
                            isClient={false}
                            handleChangeField={handleChangeJob}

                            labelSx={2}
                            labelMd={2}

                            inputSx={9}
                            inputMd={9}
                        />

                        <AutocompleteComponent
                            fieldId={'input-invoice-work_order'}
                            fieldName={'Work order'} 
                            fieldValue={workOrder}
                            attributeName={'work_order'}
                            optionList={activeWorkOrders}
                            optionAttributeLabel={'title'}
                            isClient={false}
                            handleChangeField={handleChangeWorkOrder}

                            labelSx={2}
                            labelMd={2}

                            inputSx={9}
                            inputMd={9}
                        />

                        <SelectComponent
                            fieldName={"Status"} 
                            fieldValue={ status } 
                            fieldId={'input-workOrder-status'} 
                            attributeName={'status'} 
                            optionList={visibleStatus}
                            optionAttributeName={'name'}
                            handleChangeField={handleChangeStatus}

                            labelSx={2}
                            labelMd={2}

                            inputSx={9}
                            inputMd={9}
                        />
                        
                        <Grid item sx={constants.styles.sectionInput} xs={12} md={12}>
                            &nbsp;
                        </Grid>

                        <Grid sx={constants.styles.sectionError} item xs={12} md={12}>
                            <ErrorMessageChip message={errorMessage} />
                        </Grid>
                        <Grid sx={constants.styles.sectionError} item xs={12} md={12}>
                            <SuccessMessageChip message={successMessage} setMessage={setSuccessMessage} />
                        </Grid>

                        <Grid item sx={constants.styles.sectionInput} xs={12} md={12}>
                            &nbsp;
                        </Grid>

                        <Grid item xs={12} md={12} sx={constants.styles.sectionTable}>
                            <TableContainer component={Paper} variant="outlined">
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={constants.styles.tableHeader} >Invoice number</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} >Client</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} >Job</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} >Work order</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} >Issued</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} >Due date</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} >Status</TableCell>
                                            <TableCell sx={constants.styles.tableHeader} align="center">Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {tableRows.map((row) => (
                                        <TableRow
                                            key={row.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell sx={constants.styles.tableCell} component="th" scope="row">
                                                <Link 
                                                    component="button"
                                                    onClick={() => handleEditInvoice(row.id)}
                                                >
                                                    {row.invoice_number}
                                                </Link>
                                            </TableCell>
                                            <TableCell sx={constants.styles.tableCell}>
                                                <Link 
                                                    component="button"
                                                    onClick={() => handleEditClient( row.client ? row.client.id : null)}
                                                >
                                                    {row.client && row.client.user ? row.client.user.first_name + ' ' + row.client.user.last_name : '' }
                                                </Link>
                                            </TableCell>
                                            <TableCell sx={constants.styles.tableCell}>
                                                <Link 
                                                    component="button"
                                                    onClick={() => handleEditJob( row.job ? row.job.id : null)}
                                                >
                                                    {row.job  ? row.job.title : '' }
                                                </Link>
                                            </TableCell>
                                            <TableCell sx={constants.styles.tableCell}>
                                                <Link 
                                                    component="button"
                                                    onClick={() => handleEditWorkOrder( row.work_order ? row.work_order.id : null)}
                                                >
                                                    {row.work_order  ? row.work_order.title : '' }
                                                </Link>
                                            </TableCell>
                                            <TableCell sx={constants.styles.tableCell}>{ convertDateStrToString( row.issue_date ) }</TableCell>
                                            <TableCell sx={constants.styles.tableCell}>{ convertDateStrToString( row.due_date ) }</TableCell>
                                            <TableCell sx={constants.styles.tableCell}>{ getInvoiceStatusName( row.status ) }</TableCell>
                                            <TableCell sx={constants.styles.tableCell} align="center">
                                                <IconButton 
                                                    size="small" 
                                                    title="Edit invoice"
                                                    onClick={() => handleEditInvoice(row.id)}
                                                >
                                                    <EditNote/>
                                                </IconButton>
                                                <IconButton 
                                                    size="small" 
                                                    title="Delete invoice"
                                                    onClick={() => handleDeleteInvoice(row)}
                                                >
                                                    <Delete/>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                        <Grid 
                            container
                            alignItems={'flex-end'}
                            alignContent={'flex-end'}
                            flexDirection={'column'}
                        >

                            <Grid item  
                                xs={12} md={12} 
                                sx={constants.styles.sectionButtons}
                            >
                                <Button 
                                    variant="outlined" 
                                    size="small" 
                                    sx={constants.styles.buttonNormal}
                                    onClick={handleNewInvoice}
                                > 
                                        New Invoice 
                                </Button>

                            </Grid>

                        </Grid>

                    </Grid>
                    
                </Paper>

                <Dialog
                    open={openDeleteAlert}
                    onClose={handleCloseDeleteDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle
                        sx={constants.styles.textNormal}
                        id="alert-dialog-title"
                    >
                        <strong>Do you confirm to delete this invoice?</strong>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText 
                            sx={constants.styles.textNormal}
                            id="alert-dialog-description"
                        >
                            Invoice name: <strong>{ invoiceToDelete ? invoiceToDelete.invoice_number : ''}</strong>
                            <br/>If you delete this invoice will no longer be available anymore.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button 
                            variant="outlined" 
                            size="small"
                            sx={constants.styles.buttonNormal}
                            onClick={handleCloseDeleteDialog}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="outlined" 
                            size="small"
                            sx={constants.styles.buttonNormal}
                            onClick={handleConfirmDeleteInvoice} 
                            autoFocus
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
                
        </PrincipalLayout>
    );
}

export default ViewInvoices;